@if (!isLoading && protocolSiteAttributeData?.tabs?.[0]?.groups) {
<div class="add-protocol-site">
  <app-mi-form [attributeLabels]="attributeLabels" [attributeValues]="attributeValues" [moduleName]="moduleName"
    [groups]="protocolSiteAttributeData.tabs[0].groups"
    (saveData)="onSaveProtocolSite($event)" (previousClick)="onPreviousClick()" [showImg]="true"
    [isMultipleFilesUpload]="false"
    [submitBtnText]="nextBtnLabel" [previousBtnText]="previousBtnLabel" [activeIndex]="activeIndex"
    saveBtnId="protocolSiteSaveBtnId"
    [showCancelButton]="true" (onCancel)="onCancel()"></app-mi-form>
</div>
} @else {
<div class="loading-spinner">
  <p-progressSpinner></p-progressSpinner>
</div>
}